/* eslint-disable max-classes-per-file */
import { SttChunkStateStatus } from '@ftr/contracts/regional-api/stt'
import { Uuid } from '@ftr/contracts/type/shared'
import { LocalDateTime } from '@js-joda/core'

export class AudioSegmentWithSttRemarks {
  id: Uuid
  remarks: SttRemark[]
  showSpeakers: boolean
}

export class SttWithRemarks {
  recordingId: Uuid
  remarks: SttRemark[]
}

/**
 * An SttRemark is:
 * 1) A word or group of words spoken at a time
 * 2) A placeholder for a failed/in progress chunk of time
 */
export class SttRemark {
  /**
   * Note: this is currently an utterance worth of words.
   * `content` is undefined for chunk states
   */
  content?: string
  /**
   * The time it was spoken from
   */
  startTime: LocalDateTime
  /**
   * The time it was spoken until
   */
  endTime: LocalDateTime
  /**
   * The id of the speaker
   * speakerId is undefined for chunk states
   */
  speakerId?: Uuid
  /**
   * The name of the speaker
   * speakerName is undefined for chunk states
   */
  speakerName?: string
  /**
   * The Stt Chunk State status - either loading or error.
   * This is not populated for utterances.
   */
  status?: SttChunkStateStatus
  /**
   * This is populated in the UI, which is used to determine if a finalized remark is sealed or not.
   * It will only apply to users with the UserGroupPermissionId. AccessSealedContent permission as
   * the API filters out sealed remarks for users without the aforementioned permission. Placeholder
   * remarks used to populate instances of SealedContentComponent will not have an isSealed property.
   */
  isSealed?: boolean
  isSealedContentMarker?: boolean

  /**
   * Populated by the UI: sometimes we want to conceptually 'group' a subset of the SttRemarks,
   * for example we 'group' sealed segments. We don't actually contain them in DOM elements, since
   * the group's content might only be partially downloaded at request time. So the simplest way to
   * mark the boundary of any grouping is to identify the first and last remark in a grouping.
   */
  grouping?: {
    firstStartsAt?: LocalDateTime
    isFirst?: boolean
    lastEndsAt?: LocalDateTime
    isLast?: boolean
  }
}
